import { MappableModel } from './mappable-model'

export class SeMembershipCardStatus extends MappableModel {
  public color: string
  public label: string
}

export class SeMembershipCardMember extends MappableModel {
  public image?: string
  public name: string
  public number: string
}

export class SeMembershipCardOrganization extends MappableModel {
  public image?: string
  public name: string
}

export class SeAvatarGroupAvatar extends MappableModel {
  public identity: string
  public imgUrl?: string
}

export class SeMembershipCardMembership extends MappableModel {
  public effectiveAt?: string
  public eligibilityActionLabel?: string
  public eligibilityActionLink?: string
  public expiresAt?: string
  public name: string
  public status: string
}

export class SeMembershipCard extends MappableModel {
  public appleWalletLink?: string
  public detailsLink?: string
  public googlePayLink?: string
  public member: SeMembershipCardMember
  public memberships?: SeMembershipCardMembership[]
  public organizations: SeAvatarGroupAvatar[]

  public constructor(data: any) {
    super(data)
    if (!this.member) this.member = new SeMembershipCardMember({ })
    if (!this.memberships) this.memberships = [new SeMembershipCardMembership({ })]
    if (!this.organizations) this.organizations = [new SeAvatarGroupAvatar({ })]
  }

}
